import { useEstadoDeProceso } from './espera';
import { BarraDeProgreso, Rueda } from './Cargando';

/** La espera que bloquea: para lo que no se puede interrumpir, como cobrar o emitir. */
export function PantallaDeProceso({
  abierta,
  titulo = 'Procesando',
  paso,
  mensaje = 'Espere por favor, no cierre ni recargue la página',
}: {
  abierta: boolean;
  titulo?: string;
  /** Lo que se está haciendo ahora, si se sabe: «Enviando al SRI…». */
  paso?: string | null;
  mensaje?: string;
}) {
  if (!abierta) {
    return null;
  }

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-busy="true"
      aria-label={`${titulo}…`}
      className="fixed inset-0 z-[70] flex items-center justify-center bg-armazon-900/40 p-4 backdrop-blur-sm"
    >
      <div className="w-full max-w-sm rounded-2xl bg-white px-8 py-8 text-center uppercase shadow-2xl">
        <Rueda grande />
        <p className="mt-5 text-base font-bold tracking-wider text-armazon-900">{titulo}…</p>
        <p className="mt-1.5 text-xs leading-relaxed font-medium tracking-wide text-armazon-500">
          {mensaje}
        </p>
        {paso && (
          <p
            aria-live="polite"
            className="mt-4 rounded-lg bg-marca-50 px-3 py-2 text-[11px] font-semibold tracking-wider text-marca-700"
          >
            {paso}
          </p>
        )}
        <BarraDeProgreso />
      </div>
    </div>
  );
}

/** La única pantalla de la aplicación, gobernada desde `espera.ts`. Va una vez en App. */
export function AnfitrionDeProceso() {
  const { activas, paso } = useEstadoDeProceso();
  return <PantallaDeProceso abierta={activas > 0} paso={paso} />;
}
